import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as _0 from "./ics23/v1/proofs";
import * as _1 from "./auth/v1beta1/auth";
import * as _2 from "./auth/v1beta1/genesis";
import * as _3 from "./auth/v1beta1/query";
import * as _4 from "./authz/v1beta1/authz";
import * as _5 from "./authz/v1beta1/event";
import * as _6 from "./authz/v1beta1/genesis";
import * as _7 from "./authz/v1beta1/query";
import * as _8 from "./authz/v1beta1/tx";
import * as _9 from "./bank/v1beta1/authz";
import * as _10 from "./bank/v1beta1/bank";
import * as _11 from "./bank/v1beta1/genesis";
import * as _12 from "./bank/v1beta1/query";
import * as _13 from "./bank/v1beta1/tx";
import * as _14 from "./base/abci/v1beta1/abci";
import * as _15 from "./base/node/v1beta1/query";
import * as _16 from "./base/query/v1beta1/pagination";
import * as _17 from "./base/reflection/v2alpha1/reflection";
import * as _18 from "./base/v1beta1/coin";
import * as _19 from "./crypto/ed25519/keys";
import * as _20 from "./crypto/multisig/keys";
import * as _21 from "./crypto/secp256k1/keys";
import * as _22 from "./crypto/secp256r1/keys";
import * as _23 from "./crypto/hd/v1/hd";
import * as _24 from "./crypto/keyring/v1/record";
import * as _25 from "./distribution/v1beta1/distribution";
import * as _26 from "./distribution/v1beta1/genesis";
import * as _27 from "./distribution/v1beta1/query";
import * as _28 from "./distribution/v1beta1/tx";
import * as _29 from "./gov/v1beta1/genesis";
import * as _30 from "./gov/v1beta1/gov";
import * as _31 from "./gov/v1beta1/query";
import * as _32 from "./gov/v1beta1/tx";
import * as _33 from "./gov/v1/genesis";
import * as _34 from "./gov/v1/gov";
import * as _35 from "./gov/v1/query";
import * as _36 from "./gov/v1/tx";
import * as _37 from "./staking/v1beta1/authz";
import * as _38 from "./staking/v1beta1/genesis";
import * as _39 from "./staking/v1beta1/query";
import * as _40 from "./staking/v1beta1/staking";
import * as _41 from "./staking/v1beta1/tx";
import * as _42 from "./tx/signing/v1beta1/signing";
import * as _43 from "./tx/v1beta1/service";
import * as _44 from "./tx/v1beta1/tx";
import * as _45 from "./upgrade/v1beta1/query";
import * as _46 from "./upgrade/v1beta1/upgrade";
import * as _47 from "./upgrade/v1beta1/tx";
import * as _188 from "./authz/v1beta1/tx.amino";
import * as _189 from "./bank/v1beta1/tx.amino";
import * as _190 from "./distribution/v1beta1/tx.amino";
import * as _191 from "./gov/v1beta1/tx.amino";
import * as _192 from "./staking/v1beta1/tx.amino";
import * as _193 from "./gov/v1/tx.amino";
import * as _194 from "./upgrade/v1beta1/tx.amino";
import * as _195 from "./authz/v1beta1/tx.registry";
import * as _196 from "./bank/v1beta1/tx.registry";
import * as _197 from "./distribution/v1beta1/tx.registry";
import * as _198 from "./gov/v1beta1/tx.registry";
import * as _199 from "./staking/v1beta1/tx.registry";
import * as _200 from "./gov/v1/tx.registry";
import * as _201 from "./upgrade/v1beta1/tx.registry";
import * as _202 from "./auth/v1beta1/query.lcd";
import * as _203 from "./authz/v1beta1/query.lcd";
import * as _204 from "./bank/v1beta1/query.lcd";
import * as _205 from "./base/node/v1beta1/query.lcd";
import * as _206 from "./distribution/v1beta1/query.lcd";
import * as _207 from "./gov/v1beta1/query.lcd";
import * as _208 from "./staking/v1beta1/query.lcd";
import * as _209 from "./tx/v1beta1/service.lcd";
import * as _210 from "./upgrade/v1beta1/query.lcd";
import * as _211 from "./gov/v1/query.lcd";
import * as _212 from "./auth/v1beta1/query.rpc.Query";
import * as _213 from "./authz/v1beta1/query.rpc.Query";
import * as _214 from "./bank/v1beta1/query.rpc.Query";
import * as _215 from "./base/node/v1beta1/query.rpc.Service";
import * as _216 from "./distribution/v1beta1/query.rpc.Query";
import * as _217 from "./gov/v1beta1/query.rpc.Query";
import * as _218 from "./staking/v1beta1/query.rpc.Query";
import * as _219 from "./tx/v1beta1/service.rpc.Service";
import * as _220 from "./upgrade/v1beta1/query.rpc.Query";
import * as _221 from "./gov/v1/query.rpc.Query";
import * as _222 from "./authz/v1beta1/tx.rpc.msg";
import * as _223 from "./bank/v1beta1/tx.rpc.msg";
import * as _224 from "./distribution/v1beta1/tx.rpc.msg";
import * as _225 from "./gov/v1beta1/tx.rpc.msg";
import * as _226 from "./staking/v1beta1/tx.rpc.msg";
import * as _227 from "./gov/v1/tx.rpc.msg";
import * as _228 from "./upgrade/v1beta1/tx.rpc.msg";
import * as _335 from "./lcd";
import * as _336 from "./rpc.query";
import * as _337 from "./rpc.tx";
export let cosmos;
(function (_cosmos) {
  let ics23;
  (function (_ics) {
    const v1 = _ics.v1 = _objectSpread({}, _0);
  })(ics23 || (ics23 = _cosmos.ics23 || (_cosmos.ics23 = {})));
  let auth;
  (function (_auth) {
    const v1beta1 = _auth.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _1), _2), _3), _202), _212);
  })(auth || (auth = _cosmos.auth || (_cosmos.auth = {})));
  let authz;
  (function (_authz) {
    const v1beta1 = _authz.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _4), _5), _6), _7), _8), _188), _195), _203), _213), _222);
  })(authz || (authz = _cosmos.authz || (_cosmos.authz = {})));
  let bank;
  (function (_bank) {
    const v1beta1 = _bank.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _9), _10), _11), _12), _13), _189), _196), _204), _214), _223);
  })(bank || (bank = _cosmos.bank || (_cosmos.bank = {})));
  let base;
  (function (_base) {
    let abci;
    (function (_abci) {
      const v1beta1 = _abci.v1beta1 = _objectSpread({}, _14);
    })(abci || (abci = _base.abci || (_base.abci = {})));
    let node;
    (function (_node) {
      const v1beta1 = _node.v1beta1 = _objectSpread(_objectSpread(_objectSpread({}, _15), _205), _215);
    })(node || (node = _base.node || (_base.node = {})));
    let query;
    (function (_query) {
      const v1beta1 = _query.v1beta1 = _objectSpread({}, _16);
    })(query || (query = _base.query || (_base.query = {})));
    let reflection;
    (function (_reflection) {
      const v2alpha1 = _reflection.v2alpha1 = _objectSpread({}, _17);
    })(reflection || (reflection = _base.reflection || (_base.reflection = {})));
    const v1beta1 = _base.v1beta1 = _objectSpread({}, _18);
  })(base || (base = _cosmos.base || (_cosmos.base = {})));
  let crypto;
  (function (_crypto) {
    const ed25519 = _crypto.ed25519 = _objectSpread({}, _19);
    const multisig = _crypto.multisig = _objectSpread({}, _20);
    const secp256k1 = _crypto.secp256k1 = _objectSpread({}, _21);
    const secp256r1 = _crypto.secp256r1 = _objectSpread({}, _22);
    let hd;
    (function (_hd) {
      const v1 = _hd.v1 = _objectSpread({}, _23);
    })(hd || (hd = _crypto.hd || (_crypto.hd = {})));
    let keyring;
    (function (_keyring) {
      const v1 = _keyring.v1 = _objectSpread({}, _24);
    })(keyring || (keyring = _crypto.keyring || (_crypto.keyring = {})));
  })(crypto || (crypto = _cosmos.crypto || (_cosmos.crypto = {})));
  let distribution;
  (function (_distribution) {
    const v1beta1 = _distribution.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _25), _26), _27), _28), _190), _197), _206), _216), _224);
  })(distribution || (distribution = _cosmos.distribution || (_cosmos.distribution = {})));
  let gov;
  (function (_gov) {
    const v1beta1 = _gov.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _29), _30), _31), _32), _191), _198), _207), _217), _225);
    const v1 = _gov.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _33), _34), _35), _36), _193), _200), _211), _221), _227);
  })(gov || (gov = _cosmos.gov || (_cosmos.gov = {})));
  let staking;
  (function (_staking) {
    const v1beta1 = _staking.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _37), _38), _39), _40), _41), _192), _199), _208), _218), _226);
  })(staking || (staking = _cosmos.staking || (_cosmos.staking = {})));
  let tx;
  (function (_tx) {
    let signing;
    (function (_signing) {
      const v1beta1 = _signing.v1beta1 = _objectSpread({}, _42);
    })(signing || (signing = _tx.signing || (_tx.signing = {})));
    const v1beta1 = _tx.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _43), _44), _209), _219);
  })(tx || (tx = _cosmos.tx || (_cosmos.tx = {})));
  let upgrade;
  (function (_upgrade) {
    const v1beta1 = _upgrade.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _45), _46), _47), _194), _201), _210), _220), _228);
  })(upgrade || (upgrade = _cosmos.upgrade || (_cosmos.upgrade = {})));
  const ClientFactory = _cosmos.ClientFactory = _objectSpread(_objectSpread(_objectSpread({}, _335), _336), _337);
})(cosmos || (cosmos = {}));